<script lang="ts" setup>
import type { Shape } from "@/telestrations/types/canvas";
import { getKonvaComponents } from "@/telestrations/components/Konva.vue";

const konvaComponents = getKonvaComponents();
const props = defineProps<{
  shape: Shape;
}>();

const shapesStore = useShapesStore();

function handleDragEnd(e: Event) {
  shapesStore.onShapeDragEnd(e, props.shape);
}

function handleShapeClick() {
  shapesStore.selectShape(props.shape);
}

function handleTransformEnd(e: Event) {
  shapesStore.onShapeTransformEnd(e);
}
</script>

<template>
  <component
    :is="konvaComponents['vEllipse']"
    v-if="shape.name === SpotlightShapeName.ELLIPSE"
    :config="props.shape"
    @dragstart="shapesStore.onShapeDragStart"
    @dragmove="shapesStore.onShapeDragMove"
    @dragend="handleDragEnd"
    @click="handleShapeClick"
    @transformend="handleTransformEnd"
  />
  <component
    :is="konvaComponents['vRect']"
    v-else
    :config="props.shape"
    @dragstart="shapesStore.onShapeDragStart"
    @dragmove="shapesStore.onShapeDragMove"
    @dragend="handleDragEnd"
    @click="handleShapeClick"
    @transformend="handleTransformEnd"
  />
</template>
